import axios from 'axios'
import Cookies from 'js-cookie'
import router from '@/router'
import qs from 'qs'
import { clearLoginInfo } from '@/utils'
import isPlainObject from 'lodash/isPlainObject'

const http = axios.create({
  baseURL: window.SITE_CONFIG['apiURL'] ? window.SITE_CONFIG['apiURL'] : '/api/erp-admin/',
  timeout: 1000 * 180,
  withCredentials: false
})

/**
 * 请求拦截
 */
http.interceptors.request.use(config => {
  config.headers['Accept-Language'] = Cookies.get('language') || 'zh-CN';
  config.headers['token'] = Cookies.get('3d_token') || '';
  config.headers['orgId'] = sessionStorage.getItem('orgId') || localStorage.getItem('orgId');
  config.headers['coreParams'] = sessionStorage.getItem('coreParams') || localStorage.getItem('coreParams')
  config.headers['mainOrgId'] = sessionStorage.getItem('mainOrgId') || localStorage.getItem('mainOrgId');
  // 默认参数
  var defaults = {}
  // 防止缓存，GET请求默认带_t参数
  if (config.method === 'get') {
    config.params = {
      ...config.params,
      ...{ '_t': new Date().getTime() }
    }
  }
  if (isPlainObject(config.params)) {
    config.params = {
      ...defaults,
      ...config.params
    }
  }
  if (isPlainObject(config.data)) {
    config.data = {
      ...defaults,
      ...config.data
    }
    if (/^application\/x-www-form-urlencoded/.test(config.headers['content-type'])) {
      config.data = qs.stringify(config.data)
    }
  }
  return config
}, error => {
  return Promise.reject(error)
})

/**
 * 响应拦截
 */
http.interceptors.response.use(response => {
  if (response.data.code === 401 || response.data.code === 10021) {
    // clearLoginInfo()
    // router.replace({ name: 'login' })
    Cookies.remove('3d_token');
    location.reload();
    return Promise.reject(response.data.msg)
  }
  return response
}, error => {
  return Promise.reject(error)
})

export default http



// WEBPACK FOOTER //
// ./src/utils/request.js